<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div class="monitor_container-column monitor_container-column--limit-height">
    @if (isMonocular === true) {
      <div class="monitor_graph-box" [ngClass]="{ 'monitor_graph-box--single' : isSingleOsEye }">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
        <br><br>
        <div @startList class="monitor_list-container">
          @for (record of osData.slice().reverse(); track record; let i = $index) {
            <div
              @fadeAnimation
              class="monitor_list-item">
              @if (record) {
                <ng-container *ngTemplateOutlet="recordView; context: { record: record }"></ng-container>
              } @else {
                <span class="text--blink">{{'syncing' | translate | titlecase}}...</span>
              }
            </div>
          }
          @if (!isLoading && !osData?.length) {
            <small>{{ isTestDone ? ('noTestDataReceived' | translate) : ('noTestData' | translate) }}</small>
          }
        </div>
      </div>
      <div class="monitor_graph-box">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
        <div @startList class="monitor_list-container">
          @for (record of odData.slice().reverse(); track record; let i = $index) {
            <div
              @fadeAnimation
              class="monitor_list-item">
              @if (record) {
                <ng-container *ngTemplateOutlet="recordView; context: { record: record }"></ng-container>
              } @else {
                <span class="text--blink">{{'syncing' | translate | titlecase}}...</span>
              }
            </div>
          }
          @if (!isLoading && !odData?.length) {
            <small>{{ isTestDone ? ('noTestDataReceived' | translate) : ('noTestData' | translate) }}</small>
          }
        </div>
      </div>
    }

    @if (isMonocular === false) {
      <div class="monitor_graph-box monitor_graph-box--single">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'both' | translate | titlecase }}</div>
        <br><br>
        <div @startList class="monitor_list-container">
          @for (record of ouData.slice().reverse(); track record; let i = $index) {
            <div
              @fadeAnimation
              class="monitor_list-item">
              @if (record) {
                <ng-container *ngTemplateOutlet="recordView; context: { record: record }"></ng-container>
              } @else {
                <span class="text--blink">{{'syncing' | translate | titlecase}}...</span>
              }
            </div>
          }
          @if (!isLoading && !ouData?.length) {
            <small>{{ isTestDone ? ('noTestDataReceived' | translate) : ('noTestData' | translate) }}</small>
          }
        </div>
      </div>
    }
  </div>

  <div class="monitor_container-column">
    <div class="monitor_graph-box">
      @if (isTestSyncing) {
        <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
      }
      @if (question?.length) {
        <div class="monitor_eye-box">
          <div class="monitor_box-title--small text--uppercase">{{'question' | translate}}&nbsp;&nbsp;</div>
          <div class="monitor_box-title">
            @for (q of question; track $index) {
              <span>{{q}}&nbsp;</span>
            }
          </div>
          <br>
            <div class="monitor_box-title--small text--uppercase">{{'answer' | translate}}&nbsp;&nbsp;</div>
            <div class="monitor_box-title">
              @for (v of variants; track $index) {
                <span
                  [ngClass]="{'green': answer.includes(v) && question.includes(v), 'red': answer.includes(v) && !question.includes(v)}">{{v}}
                </span>
              }
            </div>
            <br>
              <div class="monitor_box-title--small">{{ 'currentlyTesting' | translate | titlecase }}: {{ currentEye }}</div>
            </div>
          }
        </div>

        <div class="monitor_graph-box">
          @if (isTestSyncing) {
            <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
          }
          <app-percentage-circle
            id="test-percentage"
            class="monitor_circle-box"
            [percentage]="getPercentageDone()">
          </app-percentage-circle>
        </div>
      </div>
    </app-monitor-layout>

    <ng-template #recordView let-record="record">
      {{record.index}}
      <i class="fas fa-eye" [ngClass]="{ 'orange': !record?.correct, 'color-primary': record?.correct }"></i>
      <span
        matTooltip="{{ 'contrast' | translate | titlecase }}"
        class="pointer">
        {{ record?.contrast }}
      </span>

      <div style="flex-basis: 20%;">
        @for (a of record.answer.split(''); track $index) {
          <span
            class="red"
            [ngClass]="{'green': record.question.split('').includes(a)}">{{a}}
          </span>
        }
      </div>

      <span>
        {{ record?.correct ? ('seen' | translate) : ('unseen' | translate) }}
      </span>
    </ng-template>

